var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5365 8.32912C9.74521 6.08858 7.41304 4.581 4.80601 5.09741C2.89863 5.48055 1.34941 7.00478 0.949607 8.91216C0.266616 12.1356 2.71539 14.9925 5.8305 14.9925C8.00441 14.9925 9.85349 13.6015 10.5365 11.6608H14.1597V13.3266C14.1597 14.2428 14.9093 14.9925 15.8255 14.9925C16.7417 14.9925 17.4913 14.2428 17.4913 13.3266V11.6608C18.4075 11.6608 19.1572 10.9112 19.1572 9.99496C19.1572 9.07875 18.4075 8.32912 17.4913 8.32912H10.5365ZM5.8305 11.6608C4.91429 11.6608 4.16467 10.9112 4.16467 9.99496C4.16467 9.07875 4.91429 8.32912 5.8305 8.32912C6.74671 8.32912 7.49633 9.07875 7.49633 9.99496C7.49633 10.9112 6.74671 11.6608 5.8305 11.6608Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChave);
export default __webpack_public_path__ + "static/media/chave.2cc9c0d50f7ed25f7e83ae9e9ffa7fbd.svg";
export { ForwardRef as ReactComponent };